import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { UserPlus, CreditCard, Gift } from 'lucide-react';
import { RegistrationModal } from './RegistrationModal';
const steps = [{
  icon: UserPlus,
  title: 'Regístrate',
  description: 'Completa un formulario simple con tus datos básicos.',
  number: '01'
}, {
  icon: CreditCard,
  title: 'Recibe tu tarjeta',
  description: 'Obtén tu Emprende Fullpass digital al instante y comienza a disfrutar.',
  number: '02'
}, {
  icon: Gift,
  title: 'Disfruta beneficios',
  description: 'Accede a descuentos, capacitaciones y oportunidades exclusivas.',
  number: '03'
}];
export function HowItWorks() {
  const [isRegistrationOpen, setIsRegistrationOpen] = useState(false);
  return <>
      <section className="py-24 bg-gradient-to-br from-[#E8F4F8] to-[#F0F7ED]" data-id="element-107">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-108">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-center mb-16" data-id="element-109">
            <h2 className="text-4xl font-bold text-[#2C3E50] mb-4" data-id="element-110">
              Cómo funciona
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-111">
              Tres pasos simples para comenzar a disfrutar de todos los
              beneficios
            </p>
          </motion.div>

          <div className="grid md:grid-cols-3 gap-8 lg:gap-12" data-id="element-112">
            {steps.map((step, index) => {
            const Icon = step.icon;
            return <motion.div key={step.title} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: index * 0.15
            }} className="relative" data-id="element-113">
                  <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300" data-id="element-114">
                    {/* Step number */}
                    <div className="absolute -top-4 -left-4 w-12 h-12 bg-[#5B9BD5] text-white rounded-full flex items-center justify-center font-bold text-lg shadow-lg" data-id="element-115">
                      {step.number}
                    </div>

                    <div className="w-16 h-16 bg-[#E8F4F8] rounded-xl flex items-center justify-center mb-6 mt-2" data-id="element-116">
                      <Icon className="w-8 h-8 text-[#5B9BD5]" data-id="element-117" />
                    </div>

                    <h3 className="text-2xl font-semibold text-[#2C3E50] mb-3" data-id="element-118">
                      {step.title}
                    </h3>

                    <p className="text-gray-600 leading-relaxed" data-id="element-119">
                      {step.description}
                    </p>
                  </div>

                  {/* Connector line */}
                  {index < steps.length - 1 && <div className="hidden md:block absolute top-1/2 -right-6 lg:-right-12 w-6 lg:w-12 h-0.5 bg-gradient-to-r from-[#5B9BD5] to-[#6B9B5F]" data-id="element-120" />}
                </motion.div>;
          })}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.5
        }} className="text-center mt-16" data-id="element-121">
            <button onClick={() => setIsRegistrationOpen(true)} className="bg-[#5B9BD5] text-white px-10 py-4 rounded-lg font-semibold shadow-lg hover:bg-[#4A8AC4] transition-colors text-lg" data-id="element-122">
              Comenzar ahora
            </button>
          </motion.div>
        </div>
      </section>

      <RegistrationModal isOpen={isRegistrationOpen} onClose={() => setIsRegistrationOpen(false)} data-id="element-123" />
    </>;
}